import {
	Breadcrumbs,
	Card,
	Grid,
	Typography,
	Switch,
	makeStyles,
} from "@material-ui/core/";
import { SettingsBackupRestore } from "@material-ui/icons";
import MaterialTable from "material-table";
import Swal from "sweetalert2";
import { useSnackbar } from "notistack";
import AlertNotistack from "../../components/molecules/AlertNotistack";

const useStyles = makeStyles((theme) => ({
	title: {
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	},
}));

const TableOnUsers = (props) => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const {
		getDataTables,
		BaseUrl,
		tableRef,
		modalAdd,
		modalEdit,
		pageSize,
		fetchAPI,
	} = props;

	const handleStatus = async (rowData) => {
		if (rowData.status_user === 1) {
			rowData.status_user = 0;
		} else {
			rowData.status_user = 1;
		}
		const result = await fetchAPI("editstatus_user", {
			id: rowData.id,
			status_user: rowData.status_user,
		});
		return result;
	};

	const handleResetPassword = async (rowData) => {
		try {
			Swal.fire({
				type: "success",
				title: `Anda yakin ingin Reset password ${rowData.nama_user}? `,
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Tidak",
			}).then(async (res) => {
				if (res.isConfirmed) {
					const result = await fetchAPI("resetPassword", { id: rowData.id });
					return result;
				}
			});
		} catch (error) {
			enqueueSnackbar(error.message, AlertNotistack(error.status));
			throw error;
		}
	};

	const columns = [
		{ title: "Username", field: "username", editable: "false" },
		{ title: "Role", field: "role" },
		{ title: "EMAIL", field: "email" },
		{ title: "Nama User", field: "nama_user" },
		{ title: "Telepon", field: "telp" },
		{
			title: "Status User",
			field: "status_user",
			filtering: false,
			headerStyle: {
				textAlign: "center",
			},
			render: (rowData) => (
				<>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>InActive</Grid>
						<Switch
							checked={rowData.status_user ? 1 : 0}
							onChange={() => handleStatus(rowData)}
							color="primary"
							inputProps={{ "aria-label": "primary checkbox" }}
						/>
						<Grid item>Active</Grid>
					</Grid>
				</>
			),
		},
	];
	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
			style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
		>
			<Grid item>
				<Card className={classes.title}>
					<Breadcrumbs aria-label="breadcrumb" style={{ padding: "10px" }}>
						<Typography color="textPrimary" style={{ padding: "10px" }}>
							Dashboard
						</Typography>
						<Typography color="textPrimary" variant="h6">
							Users
						</Typography>
					</Breadcrumbs>
				</Card>

				<div
					style={{
						marginTop: "20px",
						boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
					}}
				>
					<MaterialTable
						title="Users Register"
						tableRef={tableRef}
						columns={columns}
						data={getDataTables({ url: `${BaseUrl}` })}
						actions={[
							{
								icon: "add_box",
								tooltip: "Add",
								isFreeAction: true,
								onClick: () => modalAdd(),
							},
							{
								icon: SettingsBackupRestore,
								iconProps: { style: { fontSize: "20px", color: "green" } },
								tooltip: "Reset Password",
								onClick: (evt, rowData) => handleResetPassword(rowData),
							},
							{
								icon: "edit",
								iconProps: { style: { fontSize: "20px", color: "green" } },
								tooltip: "Edit",
								onClick: (evt, rowData) => modalEdit(rowData),
							},
						]}
						options={{
							actionsColumnIndex: -1,
							paginationType: "stepped",
							pageSize: pageSize,
							pageSizeOptions: [5, 10, 50, 100],
							headerStyle: {
								backgroundColor: "#67A3D5",
								color: "#FFF",
							},
						}}
					/>
				</div>
			</Grid>
		</Grid>
	);
};

export default TableOnUsers;
